import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

export type SplitBillOption = 'EVENLY' | 'CUSTOM_AMOUNT' | 'PAY_FOR_ITEMS';
type PaymentMode = 'split' | 'custom_amount' | 'item_selection';

type SplitOptionConfig = {
  key: SplitBillOption;
  labelKey: string;
};

export type SplitBillOptionsSheetData = {
  paymentMode?: string | null;
};

@Component({
  selector: 'app-split-bill-options-sheet',
  templateUrl: './split-bill-options.sheet.html',
  styleUrls: ['./split-bill-options.sheet.scss'],
  standalone: false
})
export class SplitBillOptionsSheet {
  public options: SplitOptionConfig[] = [
    { key: 'EVENLY', labelKey: 'PAY_AT_TABLE.SPLIT_EVENLY' },
    { key: 'CUSTOM_AMOUNT', labelKey: 'PAY_AT_TABLE.CUSTOM_AMOUNT' },
    { key: 'PAY_FOR_ITEMS', labelKey: 'PAY_AT_TABLE.PAY_FOR_ITEMS' },
  ];

  constructor(
    private ref: MatBottomSheetRef<SplitBillOptionsSheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: SplitBillOptionsSheetData | null
  ) {
    const paymentMode = (data?.paymentMode || null) as PaymentMode | null;
    if (paymentMode) {
      const map: Record<PaymentMode, SplitBillOption> = {
        split: 'EVENLY',
        custom_amount: 'CUSTOM_AMOUNT',
        item_selection: 'PAY_FOR_ITEMS',
      };
      const allowed = map[paymentMode];
      this.options = this.options.filter((opt) => opt.key === allowed);
    }
  }

  close(): void {
    this.ref.dismiss();
  }

  pick(option: SplitBillOption): void {
    this.ref.dismiss(option);
  }
}
